<script>
    import { loadScript } from "@paypal/paypal-js";
    import { api_get, api_post } from "../util/api_request";
    import StatusMessage from "../include/StatusMessage.svelte";
    import { createEventDispatcher, onMount } from "svelte";
    import { user_info } from "../util/stores";

    const dispatch = createEventDispatcher();
    
    let response_msg;
    
    let load_paypal = (client_id) => loadScript({ "client-id": client_id, "currency": "SEK", "components": "buttons"}).then((paypal) => {
        paypal
        .Buttons({
            style: {
                color: "blue",
                // shape: "pill",
            },
            createOrder: async () => {
                // Set up the transaction
                let response = await api_post("/api/user/donation");

                if (response.status == 200)
                    return response.data.id;
                else
                    response_msg = response;
            },
            onApprove: async (data, actions) => {
                let response = await api_post(`/api/user/donation/${data.orderID}/capture`);
                let order_data = response.data;
                const error_detail = order_data?.details?.[0];

                // Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                if (error_detail?.issue === "INSTRUMENT_DECLINED")
                    return actions.restart();

                // Show response message, whether purchase was successful or not
                response_msg = response;
                // Update user info to match new state if purchase was successful
                dispatch("update_user_info");
            }
        })
        .render("#paypal-button-container");
    });

    let payment_info;
    let paypal_loaded = false;

    onMount(async () => {
        payment_info = await api_get("/api/user/payment_info");

        if (payment_info.status == 200) {
            // Load paypal if we could access paypal client id
            await load_paypal(payment_info.data.client_id);
            paypal_loaded = true;
        }
    })
</script>


<div class="container">
    <StatusMessage message={response_msg} />
    {#if $user_info.data && $user_info.data.donor}
    <div class="container green">You are a donator! Thank you for your support.</div>
    {/if}
    <h1>Donation</h1>
    <p>Thank you so much for considering a donation.</p>
    <p>Things to know:</p>
    <ul>
        <li>Donations are used exclusively for maintaining the server and potential server upgrades.</li>
        <li>By donating you will receive donator status on the minecraft server, 
            granting you the ability to invite other players.</li>
        <li>You will also receive a golden name in game!</li>
    </ul>
    <div class="container donation-box">
        {#if $user_info.data}
            <h2 class="center">Pay with PayPal</h2>
            <div class:hidden={!paypal_loaded} id="paypal-button-container"></div>
            {#if !paypal_loaded}
            <span class="center loading">Loading PayPal...</span>
            {/if}
        {:else}
            <span class="center">Donations are only accepted by registered players.</span>
        {/if}
    </div>
</div>

<style>
    .container.donation-box {
        max-width: 400px;
        margin: 40px auto;
        background-color: #fafafa;
    }

    .loading {
        margin: 20px 0;
    }
</style>